import { InformationSlabSymbolIcon } from './InformationSlabSymbolIcon';

/**
 * author: Jeff Anders
 * id ACA42E0C-6EEF-47B6-8824-FD916C58E87F
 * name information-slab-symbol
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-symbol.svg
 * tags
 * - Settings 
 */
export const InfoSlabSymbolIcon = InformationSlabSymbolIcon;
export default InfoSlabSymbolIcon